module.exports = __webpack_public_path__ + "static/img/passion-06.fbfdb98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/passion-06.png
// module id = 131
// module chunks = 0